import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  background-color: ${theme.colors.white};
  padding: 16px;
  border-radius: ${theme.border.mediumRadius};
`

export const Name = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
`

export const Score = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray700};
`

export const Position = styled.div`
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  width: 24px;
`
